import { useHierarchyStore } from '../dal/hierarchy-store';
import { agglomerativeClustering } from '../domain/hierarchy-provider';
import Dendrogram from './dendrogram';
import { round } from '../../cluster-provider';

const HierarchyView = () => {

    const params = useHierarchyStore(store => store.params);
    const linkage = useHierarchyStore(store => store.linkage);
    const distance = useHierarchyStore(store => store.distance);
    const isSimilarityMatrix = useHierarchyStore(store => store.isSimilarityMatrix);

    const { steps, map, rootId, calculations } = agglomerativeClustering(params, linkage, distance, isSimilarityMatrix);

    const letters: string[] = [];

    for(const step of steps) {
        for(const letter of step.clusters) {
            if(letters.includes(letter)) continue;
            letters.push(letter);
        }
    }

    return (
        <div className="flex gap-4 items-start">
            {
                steps &&
                <div>

                    {
                        isSimilarityMatrix &&
                        <div className="mb-4 border p-4 rounded">
                            <div className="mb-1 font-bold">Similarity Matrix</div>
                            {
                                params.table.map((row, index) => (
                                    <div key={ `similarity-row-${index}` }>
                                        { JSON.stringify(row.map( item => round(1 - item) ))}
                                        {
                                            (index < params.table.length - 1) &&
                                            <span>,</span>
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    }

                    {
                        steps.map((step, i) => {
                            return (
                                <div key={ i }>
                                    <strong>{ step.clusters.join(',') }</strong> - { step.distance }
                                </div>
                            )
                        })
                    }

                    <Dendrogram
                        map={ map }
                        root={ rootId }
                        letters={ letters }
                    />

                    {
                        calculations.map((calculation, i) => {
                            return (
                                <div key={ `calc-${ i }` }>
                                    { calculation }
                                </div>
                            )
                        })
                    }
                </div>
            }
        </div>
    )
};

export default HierarchyView;